import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Input, notification } from "antd";

import { api } from "../../api";
import AuthCard from "../../components/auth/AuthCard";
import { loginStore } from "../../stores/loginStore";
import { usePageTitle } from "../../utils/usePageTitle";
import { usePendingAction } from "../../utils/usePendingAction";
import { validateEmail } from "../../utils/validateEmail";

import "./PasswordRecoveryPage.css";

export const PasswordRecoveryPage = () => {
  const { t } = useTranslation();
  usePageTitle(t("passwordRecovery.title"));
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(
    (location.state as { email?: string })?.email ?? loginStore.email ?? "",
  );
  const [emailError, setEmailError] = useState("");
  const { pending: loading, run: runSend } = usePendingAction();

  async function handleSend() {
    if (!email || !validateEmail(email)) {
      setEmailError(t("errors.shared.invalid_email"));
      return;
    }
    await runSend(async () => {
      setEmailError("");
      try {
        await api.auth.resetPassword(email);
        loginStore.setEmail(email);
        navigate("/password/reset/done");
      } catch {
        notification.error({ message: t("errors.shared.common_error") });
      }
    });
  }

  return (
    <AuthCard>
      <h1>{t("passwordRecovery.title")}</h1>
      <p>{t("passwordRecovery.description")}</p>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSend();
        }}
      >
        <Input
          type="text"
          name="username"
          allowClear
          placeholder={t("app.yourEmail")}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (emailError) setEmailError("");
          }}
          onPressEnter={handleSend}
          autoComplete="username"
          size="large"
          status={emailError ? "error" : undefined}
        />
        {emailError && <div className="email-error">{emailError}</div>}

        <Button
          type="primary"
          size="large"
          block
          loading={loading}
          style={{ marginTop: 16 }}
          onClick={handleSend}
        >
          {t("passwordRecovery.sendInstructions")}
        </Button>
      </form>

      <div style={{ marginTop: 16, fontSize: 14 }}>
        <Trans
          i18nKey="passwordRecovery.orGoBackTo"
          components={{ lnk: <Link to="/login/1" state={{ email }} /> }}
        />
      </div>
    </AuthCard>
  );
};
